/* ==========================================================================
   main.js —— Te-HoloOrb 專案共用一份，所有頁面都 link 這個檔案
   目前只有一個功能：置中露出式輪播（.orb-carousel）的箭頭與分頁點
   ========================================================================== */

/* --------------------------------------------------------------------------
   CAROUSEL —— MAKE THE SPACE YOURS 那一區

   跟卡片本身有幾張無關，分頁點的數量固定等於卡片數量（不像 Coolify 官網
   .feature-scroll 那樣會隨斷點改變有意義的停靠點數），所以分頁點直接寫死在
   HTML 裡，這裡不用像官網那樣動態產生按鈕，只需要「掛事件＋同步狀態」。

   每一張卡片都設了 scroll-snap-align: center，所以只要把 scrollLeft
   移到「某張卡片的正中央」，瀏覽器就會自動吸附對齊，不用自己算捲動終點。

   頁面上沒有這個區塊時會自動跳過，所以每一頁都可以安全載入這支檔案。
   -------------------------------------------------------------------------- */
document.querySelectorAll('.orb-carousel').forEach(function (section) {
  var track = section.querySelector('.orb-carousel__track');
  if (!track) return;

  var slides = Array.prototype.slice.call(track.children);
  var dots = Array.prototype.slice.call(section.querySelectorAll('.orb-carousel__dot'));
  var prev = section.querySelector('.orb-carousel__arrow--prev');
  var next = section.querySelector('.orb-carousel__arrow--next');

  var stops = [];   // 每張卡片「置中」時對應的 scrollLeft 值

  /* 卡片置中時的 scrollLeft = 卡片自己的中心點，減去可視範圍一半的寬度 */
  function buildStops() {
    stops = slides.map(function (slide) {
      return slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2;
    });
  }

  function maxScroll() {
    return track.scrollWidth - track.clientWidth;
  }

  /* 頭尾兩張卡片沒有多餘空間可以捲，天生沒辦法完全置中——
     捲到底／捲到頭就是它們的極限，夾在合法範圍內，不會捲出界。
     （這是刻意的簡化：只有 3 張卡片，且沒有另外留左右緩衝空間，
     頭尾兩張會比中間那張稍微偏一點，中間那張永遠精準置中。） */
  function clampStops() {
    var max = maxScroll();
    stops = stops.map(function (position) {
      return Math.max(0, Math.min(position, max));
    });
  }

  /* 目前最接近哪一張卡片 */
  function currentStop() {
    var nearest = 0;
    var min = Infinity;

    stops.forEach(function (position, i) {
      var distance = Math.abs(position - track.scrollLeft);
      if (distance < min) {
        min = distance;
        nearest = i;
      }
    });

    return nearest;
  }

  /* 箭頭：往前／往後移動一張（跟分頁點共用同一份 stops，兩者不會不同步） */
  function goBy(delta) {
    var target = currentStop() + delta;
    if (target < 0) target = 0;
    if (target > stops.length - 1) target = stops.length - 1;
    track.scrollTo({ left: stops[target], behavior: 'smooth' });
  }

  if (prev) prev.addEventListener('click', function () { goBy(-1); });
  if (next) next.addEventListener('click', function () { goBy(1); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      track.scrollTo({ left: stops[i], behavior: 'smooth' });
    });
  });

  /* 更新亮的分頁點 + 箭頭能不能按 */
  function sync() {
    var active = currentStop();

    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === active);
      if (i === active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    var max = maxScroll();
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= max - 1;
  }

  /* 只有「第一次」才把畫面停在中間那張；之後每次 rebuild（resize、圖片載入
     完成）都只是重新量測 stops、同步分頁點與箭頭狀態，不會動使用者目前的
     捲動位置。少了這個開關的話，任何一次 resize（包含手機轉方向、瀏覽器
     工具列縮放這種小變化）都會把使用者剛點過去的那張卡片蓋掉、強制跳回
     預設的中間張——這是實測抓到的真實 bug，不是理論上的疑慮。 */
  var hasCentered = false;

  function rebuild() {
    buildStops();
    clampStops();

    if (!hasCentered) {
      /* 初始畫面停在中間那張（有奇數張卡片時最準確；只有 2 張的話會停在第 1 張） */
      track.scrollLeft = stops[Math.floor((stops.length - 1) / 2)] || 0;
      hasCentered = true;
    }

    sync();
  }

  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', rebuild);
  window.addEventListener('load', rebuild);   /* 圖片載入後尺寸可能變，重算一次 */
  rebuild();
});